const getDefaultState = () => {
  return {
    sessionInfo: {},
    productData: [],
    ticketsData: []
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_SESSION: (state, session) => {
    state.sessionInfo = session ? { ...state.session, ...session } : {};
  },
  SET_TICKET_PRODUCT: (state, { products, tickets }) => {
    state.productData = products || [];
    state.ticketsData = tickets || [];
  },
  RESET: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  //show snackbar
  setSession({ commit }, session) {
    commit("SET_SESSION", session);
  },
  setTicketProduct({ commit }, payload) {
    commit("SET_TICKET_PRODUCT", payload);
  }
};

const getters = {
  sessionInfo: state => state.sessionInfo,
  productData: state => state.productData,
  ticketsData: state => state.ticketsData
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
